(function() {
    angular
        .module('emarket.commons')
        .directive('customField', ['$log', '$templateCache', '$compile', '$mdMedia', function($log, $templateCache, $compile, $mdMedia) {
            return {
                scope: {
                    field: '=',
                    ngModel: '=',
                    refresh: '=',
                    onChange: '&',
                    edit: '=?'
                },
                controller: 'CustomFieldController as vm',
                link: function(scope, element) {
                    var fieldType = scope.field.showAs;
                    var t = 'directives/custom-fields/types/' + fieldType + '.tpl.html';
                    if ($mdMedia('xs') || $mdMedia('sm')) {
                        t = 'directives/custom-fields/types/mobile.tpl.html';
                    }
                    var template = $templateCache.get(t);
                    if (scope.edit) {
                        element.addClass('editing');
                    }
                    element.append($compile(template)(scope));
                }
            };
        }]);
}());
